import { api } from 'config/index';

let attemptAtService = {
    search: 0
};

let controllersRequest = {
    searchSuggestions: null
};

const _searchSuggestions = (query) => {
    if(!query) return Promise.resolve([]);

    if (controllersRequest.searchSuggestions) {
        controllersRequest.searchSuggestions.abort();
        controllersRequest.searchSuggestions = null;
    }

    let reqOptions = {
        headers: {
            'x-api-key': api.apiKey
        }
    };

    if (window && window.AbortController) {
        controllersRequest.searchSuggestions = new AbortController();
        reqOptions.signal = controllersRequest.searchSuggestions.signal;
    }

    return fetch(api.search + `/search-suggestions/${query}`, reqOptions)
        .then(results => results.json())
        .then(results => _validationError('search', () => _searchSuggestions(query), results))
        .then(results => {
            controllersRequest.searchSuggestions = null;
            if(results.status){
                results = [];
            }
            return results;
        })
        .catch(error =>{
            controllersRequest.searchSuggestions = null;
            if(error.toString() === 'AbortError: The user aborted a request.') return false;
            return _validationError('search', () => _searchSuggestions(query));
        });
};

const _validationError = (name, callback, results = null) => {
    if(!(results && !(results.status && (results.message || results.statusMessage)))){
        return _attemptByError(name, callback);
    }

    attemptAtService[name] = 0;
    return results;
};

const _attemptByError = (name, callback) => {
    attemptAtService[name] = attemptAtService[name] + 1;

    if(attemptAtService[name] > 3){
        attemptAtService[name] = 0;
        return false;
    } else{
        return callback();
    }
}

const SearchService = {
    searchSuggesions: _searchSuggestions
};

export default SearchService;
